if (!customElements.get("quiz-upsell")) {
  customElements.define(
    "quiz-upsell",
    class QuizUpsell extends HTMLElement {
      constructor() {
        super();
        // alert(1);
        this.subscribeButton = document.querySelectorAll(
          "button.subscription-button"
        );
        this.addToCartButton = document.querySelectorAll(
          "button.add-to-cart-button"
        );
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.subscribeButton.forEach((button) => {
          button.addEventListener("click", this.onSubscribeClick.bind(this));
        });
        this.addToCartButton.forEach((button) => {
          button.addEventListener("click", this.onAddToCardClick.bind(this));
        });
      }
      ajaxAddToCart(config) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((response) => {
            console.log(response);
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.log("Error:", error);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }

      formDataFunction(variantId, sellingId) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const productFromData = new FormData();
        // Manually append form data
        productFromData.append("id", variantId);
        productFromData.append("quantity", 1);
        productFromData.append("properties[quiz_product]", true);
        console.log("productFromData", productFromData);
        if (sellingId) {
          productFromData.append("selling_plan", sellingId);
        }
        if (this.cart) {
          productFromData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          productFromData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = productFromData;
        this.ajaxAddToCart(config);
      }

      onSubscribeClick(evt) {
        const buttonEvt = evt.currentTarget;
        const sellingId = buttonEvt?.dataset?.sellingId;
        const variantId = buttonEvt?.dataset?.variantId;
        console.log("Variant ID:", buttonEvt?.dataset?.variantId);
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        this.formDataFunction(variantId, sellingId);
      }

      onAddToCardClick(evt) {
        const buttonEvt = evt.currentTarget;
        const variantId = buttonEvt?.dataset?.variantId;
        console.log("Variant ID:", buttonEvt?.dataset?.variantId);
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        this.formDataFunction(variantId);
      }
    }
  );
}
